export default (riskQuestionnaireType)=>[{
    "id": 1,
    "title": "",
    "active": true,
    "component": "Welcome"
},
{
    "id": 2,
    "title": "Risk Tolerance",
    "active": false,
    "component": riskQuestionnaireType
},
{
    "id": 3,
    "title": "KYC",
    "active": false,
    "component": "KYC10"
},
{
    "id": 4,
    "title": "Thank You",
    "active": false,
    "component": "thankyou"
}
]